module.exports = __webpack_public_path__ + "static/img/alldevicetype.31e4664a.png";